export default () => ({
	active_item: '',
	select: document.querySelector('#duftnoten-select'),

	init() {
		this.select.addEventListener('change', () => {
			this.active_item = this.select.value.toLowerCase().trim();
		});
	},
});
